// extracted by mini-css-extract-plugin
export default {"cta":"LH-z","disabled":"MH-z"};